export const applyProjectAddress = 'https://docs.google.com/forms/d/1C23eS3kUe2GWR-W1kJgmLaGy5qE2vnN5PMfolzyfKp4/edit';
export const PageName = 'Sigma Launchpad';
export const PageNamePath = 'launchpad';
export const getPageDetailUrl = (id) => (`/${PageNamePath}/${id}`);